import React, { useId } from 'react';
import styles from './AppSwitch.module.scss';

/**
 * Toggle on/off del Design System (track + thumb), per valori booleani.
 * Più chiaro di una checkbox grezza. Emette un evento change nativo
 * (e.target = checkbox), quindi è compatibile con gli handler `handleChange`
 * che leggono `name` / `checked` / `type === 'checkbox'`.
 *
 * Props: name, checked, onChange, label, disabled, id
 */
export default function AppSwitch({
  name,
  checked = false,
  onChange,
  label,
  disabled = false,
  id,
}) {
  const autoId = useId();
  const inputId = id || autoId;
  return (
    <label className={styles.switch} htmlFor={inputId}>
      <input
        id={inputId}
        type="checkbox"
        role="switch"
        name={name}
        checked={!!checked}
        onChange={onChange}
        disabled={disabled}
        className={styles.input}
        aria-checked={!!checked}
      />
      <span className={styles.track} aria-hidden="true" />
      {label && <span className={styles.label}>{label}</span>}
    </label>
  );
}
